import { OrganizationRole } from '@moovit-sp-gmbh/hcloud-sdk/lib/interfaces/idp'
import { checkOrgRole } from '~/helper/OrganizationRoleChecker'

export const useOrganizationRole = async (orgName: string, requiredRole: OrganizationRole) => {
  const { permissionCacheStore: cacheStore } = await useStore('permissionCacheStore')

  const organization = await cacheStore.getOrganization(orgName)
  return checkOrgRole(organization?.roleOfUser, requiredRole)
}

export const useOrganizationRoleAsRef = (orgName: string, requiredRole: OrganizationRole): globalThis.Ref<boolean> => {
  const res = ref(false)

  usePermissionCacheStore().then(cacheStore => {
    cacheStore.getOrganization(orgName).then(organization => {
      res.value = checkOrgRole(organization?.roleOfUser, requiredRole)
    })
  })

  return res
}
